// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // For authentication
import { initializeFirestore } from "firebase/firestore"; // For Firestore database
import { getStorage } from "firebase/storage"; // For Storage
import { getMessaging, isSupported as isMessagingSupported } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

// Your web live app's Firebase configuration

// Two Firebase projects:
//   • team-edelstein   — LIVE (production data)
//   • team-henry-demo  — DEV / SANDBOX (safe for testing)
// Local dev (`npm start` → NODE_ENV "development") uses the SANDBOX so testing
// never touches live data. A production build (`npm run build` → "production")
// uses the LIVE project. A dev-only console line below confirms which is active.

const liveConfig = {
  apiKey: "AIzaSyDo_FqutSqnAdeLAgff4ggRcWX0pg2h5XM",
  authDomain: "team-edelstein.firebaseapp.com",
  projectId: "team-edelstein",
  storageBucket: "team-edelstein.firebasestorage.app",
  messagingSenderId: "627842934381",
  appId: "1:627842934381:web:1262ee1777d45c7cb6c164",
};

const demoConfig = {
  apiKey: "AIzaSyBGb4fcrb7VFRYXDiPKAETSa6ueGcw4qH8",
  authDomain: "team-henry-demo.firebaseapp.com",
  projectId: "team-henry-demo",
  storageBucket: "team-henry-demo.firebasestorage.app",
  messagingSenderId: "475392448682",
  appId: "1:475392448682:web:6b2821dc598ac12d77d8d3",
  measurementId: "G-WZQB28ZFLC",
};

// Escape hatch: REACT_APP_USE_LIVE=1 makes `npm start` target LIVE — needed
// when a new Settings screen must write live config before the next cPanel
// upload (e.g. pasting RingCentral credentials). Use via a temporary
// .env.development.local file and DELETE it when done.
const useLive =
  process.env.NODE_ENV !== "development" ||
  process.env.REACT_APP_USE_LIVE === "1";

const firebaseConfig = useLive ? liveConfig : demoConfig;

if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  console.info(
    useLive
      ? "%c[Firebase] ⚠️ DEV POINTED AT LIVE → project:"
      : "%c[Firebase] DEV sandbox → project:",
    useLive
      ? "color:#dc2626;font-weight:bold"
      : "color:#16a34a;font-weight:bold",
    firebaseConfig.projectId,
  );
}

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Analytics and Messaging are optional, browser-dependent services. On some
// mobile contexts (iOS Safari, private mode, blocked storage/IndexedDB) their
// initialization can throw — and because this module is imported before React
// mounts, an unguarded throw here blanks the whole app. Init defensively so a
// missing capability degrades to "no analytics / no push", never a dead app.
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (err) {
  console.warn("[Firebase] Analytics unavailable:", err && err.message);
}

// Messaging (FCM/push) is browser-dependent: getMessaging() throws — as an
// UNCAUGHT async rejection — on browsers without push support, notably iOS
// Safari outside an installed PWA, and under jsdom in tests. A plain try/catch
// can't catch that async throw. Gate on isSupported() so getMessaging() is only
// ever called where it works; elsewhere `messaging` stays null and push
// features no-op. `messagingReady` resolves to the instance (or null) for
// consumers that need to wait for initialization.
let messaging = null;
const messagingReady = isMessagingSupported()
  .then((supported) => {
    if (!supported) return null;
    try {
      messaging = getMessaging(app);
    } catch (err) {
      console.warn("[Firebase] Messaging unavailable:", err && err.message);
    }
    return messaging;
  })
  .catch(() => null);

// Initialize Firebase Services
const auth = getAuth(app);
// ignoreUndefinedProperties: an undefined field means "no value — don't write
// it", never "reject the whole save". Sparse husk deals (e.g. the sourceDealId
// patch deals with no propertyphoto/leadsource/propertyaddress) otherwise make
// every edit-wizard save explode with "Unsupported field value: undefined".
// To CLEAR a field, write null (see deletedAt in firebasefunctions.js).
const firestored = initializeFirestore(app, { ignoreUndefinedProperties: true });
const storage = getStorage(app);
const functionsClient = getFunctions(app, "us-central1");

export { app, analytics, auth, firestored, storage, messaging, messagingReady, functionsClient, firebaseConfig };
